import { useState, useEffect } from 'react';

const SLIDES = [
  {
    src: 'https://storage.readdy-site.link/project_files/ab967d20-2987-4048-a339-d91f8ceb0be3/984b386a-180f-449a-ba36-d26080deaf3b_HOTEL3.png?v=01eaf5975779af63313a5517e49d8dc3',
    domain: 'Fashion Brands',
    label: 'Editorial & Campaign',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ab967d20-2987-4048-a339-d91f8ceb0be3/2db84da5-0dcd-4af3-bddc-b0017474554a_PHOTO-2.png?v=1d014d3c364ff386f7b074fe679ca0bd',
    domain: 'Fashion Brands',
    label: 'Editorial & Campaign',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ab967d20-2987-4048-a339-d91f8ceb0be3/46e34efe-d1f8-4b9c-a299-b52213ea4311_18.png?v=79bf746ffae63ae8ebe979e3b94be428',
    domain: 'Hotels',
    label: 'Architecture & Interiors',
  },
  {
    src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1800&q=90&fit=crop',
    domain: 'Restaurants',
    label: 'Gastronomy & Ambiance',
  },
];

export function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setCurrent((c) => (c + 1) % SLIDES.length), 5000);
    return () => clearInterval(id);
  }, []);

  const handleBookClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden bg-gray-900">

      {SLIDES.map((slide, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            idx === current ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ zIndex: idx === current ? 1 : 0 }}
        >
          <img
            src={slide.src}
            alt={slide.domain}
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60" />

          {/* Domain badge — bottom left, subtil et raffiné */}
          <div
            className={`absolute bottom-20 left-8 md:left-16 z-10 transition-all duration-700 ${
              idx === current ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
            }`}
            style={{ transitionDelay: idx === current ? '400ms' : '0ms' }}
          >
            <div className="flex items-center gap-3 mb-1">
              <div className="w-5 h-px bg-white/60"></div>
              <span className="font-['Montserrat'] text-[10px] uppercase tracking-[0.3em] text-white/60">
                {slide.label}
              </span>
            </div>
            <span className="font-['Cormorant_Garamond'] text-xl md:text-2xl font-light text-white/90 tracking-wide">
              {slide.domain}
            </span>
          </div>
        </div>
      ))}

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 z-10">
        <h1 className="font-['Cormorant_Garamond'] text-6xl md:text-8xl font-light text-white mb-6 tracking-wide">
          Capturing Excellence
        </h1>
        <p className="font-['Montserrat'] text-base md:text-lg text-white/90 max-w-2xl mb-8 leading-relaxed">
          Luxury photography for Fashion Brands, Hotels &amp; Restaurants — crafted in the heart of Paris
        </p>
        {/* Domain tags */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {['Fashion Brands', 'Hotels', 'Restaurants'].map((tag) => (
            <span
              key={tag}
              className="font-['Montserrat'] text-xs text-white/70 uppercase tracking-[0.25em] px-4 py-1.5 border border-white/25"
            >
              {tag}
            </span>
          ))}
        </div>
        <a
          href="#contact-section"
          onClick={handleBookClick}
          className="px-10 py-4 bg-white text-gray-900 font-['Montserrat'] text-sm tracking-wider uppercase hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
        >
          Book Your Shoot
        </a>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-3 z-10">
        {SLIDES.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            aria-label={`Slide ${idx + 1}`}
            className={`h-2 rounded-full transition-all duration-500 cursor-pointer ${
              idx === current ? 'w-8 bg-white' : 'w-2 bg-white/50 hover:bg-white/80'
            }`}
          />
        ))}
      </div>

    </section>
  );
}
